import React, { useState, useRef, useEffect } from "react";
import { Grid, Typography, IconButton, Menu, MenuItem } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import logo from "../../Recursos/logo.svg";
import IcecreamRoundedIcon from "@mui/icons-material/IcecreamRounded";
import LunchDiningRoundedIcon from "@mui/icons-material/LunchDiningRounded";
import LocalBarRoundedIcon from '@mui/icons-material/LocalBarRounded';
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import SentimentVerySatisfiedOutlinedIcon from "@mui/icons-material/SentimentVerySatisfiedOutlined";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../../firebase/firebase";

const BarraCell = () => {
    const [pos, setPos] = useState({ left: 0, width: 0 });
    const [anchorEl, setAnchorEl] = useState(null);
    const [textos, setTextos] = useState({});
    const location = useLocation();

    const comidasRef = useRef(null);
    const heladosRef = useRef(null);
    const bebidasRef = useRef(null);
    const contenedorRef = useRef(null);
    const headerRef = useRef(null);

    useEffect(() => {
        const unsub = onSnapshot(doc(db, "configuracion", "textos"), (snap) => {
            if (snap.exists()) setTextos(snap.data());
        });
        return () => unsub();
    }, []);

    const rutasMenu = ["/cono-gratis", "/danos-tu-opinion", "/pagina-misteriosa"];

    const seleccion =
        rutasMenu.includes(location.pathname)
            ? null
            : location.pathname === "/comidas" || location.pathname === "/"
                ? "comidas"
                : location.pathname === "/helados"
                    ? "helados"
                    : location.pathname === "/bebidas"
                        ? "bebidas"
                        : null;

    useEffect(() => {
        let ref = null;
        if (seleccion === "comidas") ref = comidasRef.current;
        else if (seleccion === "helados") ref = heladosRef.current;
        else if (seleccion === "bebidas") ref = bebidasRef.current;

        if (ref && contenedorRef.current) {
            const rect = ref.getBoundingClientRect();
            const contRect = contenedorRef.current.getBoundingClientRect();
            setPos({ left: rect.left - contRect.left, width: rect.width });
        }
    }, [seleccion]);

    const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
    const handleMenuClose = () => setAnchorEl(null);

    return (
        <Grid
            ref={headerRef}
            container
            alignItems="center"
            sx={{ position: "fixed", width: "100%", backgroundColor: "rgba(255, 255, 255, 0.3)", backdropFilter: "blur(30px)", WebkitBackdropFilter: "blur(10px)", top: 0, zIndex: 1300, py: 1, px: 1, borderBottom: "1px solid black" }}
        >
            <Grid container alignItems="center" sx={{ width: "100%", maxWidth: "1400px", mx: "auto", display: "flex", justifyContent: "space-between" }}>

                {/* Logo */}
                <Grid item>
                    <a href="https://linktr.ee/Toppings.col" style={{ textDecoration: "none" }}>
                        <div style={{ width: 60, height: 60, borderRadius: "50%", backgroundColor: "transparent", display: "flex", alignItems: "center", justifyContent: "center", transition: "background-color 0.3s ease" }}>
                            <img src={logo} alt="Toppings Logo" style={{ width: 55, height: 55, borderRadius: "50%", cursor: "pointer" }} />
                        </div>
                    </a>
                </Grid>

                {/* Barra principal */}
                <Grid
                    ref={contenedorRef}
                    container
                    alignItems="center"
                    sx={{ position: "relative", maxWidth: "700px", flex: 7, marginLeft: 1, marginRight: 1, borderRadius: "50px", overflow: "hidden", backgroundColor: "#FFA602", px: 2, py: 0.8, display: "flex", flexDirection: "row", flexWrap: "nowrap", justifyContent: "space-between" }}
                >
                    {seleccion && (
                        <div style={{ position: "absolute", top: 4, left: pos.left - 11, width: pos.width + 23, height: "calc(100% - 8px)", backgroundColor: "#C16D00", borderRadius: "50px", transition: "all 0.5s cubic-bezier(0.77, 0, 0.175, 1)", zIndex: 0 }} />
                    )}

                    <Grid ref={comidasRef} item component={Link} to="/comidas" sx={{ color: "white", textAlign: "center", px: 1, cursor: "pointer", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", position: "relative", zIndex: 1, textDecoration: "none", whiteSpace: "nowrap" }}>
                        <LunchDiningRoundedIcon sx={{ fontSize: 22 }} />
                        <Typography sx={{ fontSize: 13, fontWeight: 100 }}>Comidas</Typography>
                    </Grid>

                    <Grid ref={heladosRef} item component={Link} to="/helados" sx={{ color: "white", textAlign: "center", px: 1, cursor: "pointer", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", position: "relative", zIndex: 1, textDecoration: "none", whiteSpace: "nowrap" }}>
                        <IcecreamRoundedIcon sx={{ fontSize: 22 }} />
                        <Typography sx={{ fontSize: 13, fontWeight: 100 }}>Helados</Typography>
                    </Grid>

                    <Grid ref={bebidasRef} item component={Link} to="/bebidas" sx={{ color: "white", textAlign: "center", px: 1, cursor: "pointer", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", position: "relative", zIndex: 1, textDecoration: "none", whiteSpace: "nowrap" }}>
                        <LocalBarRoundedIcon sx={{ fontSize: 22 }} />
                        <Typography sx={{ fontSize: 13, fontWeight: 100 }}>Bebidas</Typography>
                    </Grid>
                </Grid>

                {/* Botón ⋯ */}
                <Grid item>
                    <IconButton onClick={handleMenuOpen} sx={{ backgroundColor: "#FFA602", width: 50, height: 50, borderRadius: "50%", "&:hover": { backgroundColor: "#FFA602" } }}>
                        <MoreHorizIcon sx={{ color: "white", fontSize: 26 }} />
                    </IconButton>
                    <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={handleMenuClose}
                        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                        transformOrigin={{ vertical: "top", horizontal: "right" }}
                        PaperProps={{ sx: { borderRadius: "12px", mt: 1, boxShadow: "0px 4px 12px rgba(0,0,0,0.15)" } }}
                    >
                        <MenuItem onClick={handleMenuClose} sx={{  display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                            <Link to="/cono-gratis" style={{ textDecoration: "none", color: "black" }}>
                                <Typography sx={{ fontSize: 16, fontWeight: 300 }}>
                                    {textos.barra_cell_menu || "Reclama un helado gratis"}
                                </Typography>
                            </Link>
                            <SentimentVerySatisfiedOutlinedIcon sx={{ ml: 2, fontSize: 20 }} />
                        </MenuItem>
                    </Menu>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default BarraCell;